/* eslint-disable perfectionist/sort-enums */
// The order of items is preferred by the care providers. So please don't change.
export enum tcohV1Conclusie {
    normaal = 'Normaal',
    variant_van_normaal = 'Variant van normaal',
    nog_normaal = 'Nog normaal',
    borderline = 'Borderline',
    niet_geheel_normaal = 'Niet geheel normaal',
    abnormaal = 'Abnormaal',
    afwijkend = 'Afwijkend',
    sterk_afwijkend = 'Sterk afwijkend',
    alarmerend_afwijkend = 'Alarmerend afwijkend',
}
